import { ReactRenderer } from '@tiptap/react'
import { SuggestionOptions, SuggestionProps } from '@tiptap/suggestion';
import { MentionNodeAttrs } from '@tiptap/extension-mention';
import tippy from "tippy.js";
import { ITopicDnDResponse } from 'Data/interfaces/Activities/IDragAndDropDataFormat';
import MentionListActivity, { MentionListActivityRef } from './components/MentionListActivity'

export type SuggestionPropsType = SuggestionProps<ITopicDnDResponse, MentionNodeAttrs>

export type SuggestionType = Omit<SuggestionOptions<ITopicDnDResponse, MentionNodeAttrs>, "editor">

const activitySuggestion = (listActivities: ITopicDnDResponse[]): SuggestionType => ({
  char: '#',
  items(props) {
    return listActivities.filter(activity => {
      return activity.Identifier?.toLowerCase().includes(props.query.toLowerCase()) ||
        activity.Title?.toLowerCase().includes(props.query.toLowerCase());
    });
  },
  render: () => {
    let reactRenderer: ReactRenderer<MentionListActivityRef, SuggestionPropsType>;
    let popup: any;

    return {
      onStart: (props) => {
        reactRenderer = new ReactRenderer(MentionListActivity, {
          props,
          editor: props.editor
        });

        popup = tippy("body", {
          getReferenceClientRect: props.clientRect as any,
          appendTo: () => document.body,
          content: reactRenderer.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start"
        });
      },
      onUpdate(props) {
        reactRenderer.updateProps(props);

        popup[0].setProps({
          getReferenceClientRect: props.clientRect
        });
      },
      onKeyDown(props) {
        return reactRenderer.ref?.onKeyDown(props) ?? false;
      },
      onExit() {
        popup[0].destroy();
        reactRenderer.destroy();
      }
    };
  }
});

export default activitySuggestion;
